<template>
    <transition name="fade">
        <button class="button button-small" type="button" v-if="!isOpen" @click="open">{{ i18n.zobrazit }}</button>
        <div v-else class="academy-task-popup-wrapper" @click.self="close">
            <div class="academy-task-popup">
                <div v-if="loading" class="academy-task-loader">
                    <span class="material-icons rotating">hourglass_bottom</span>
                </div>
                <div v-else>

                    <!--                    Task detail text -->

                    <div class="warning-block" v-if="submitErrors">
                        <span class="material-icons">report_problem</span> {{ i18n.nastala_chyba_pri_spracovani_skontroljte_vsetky_polia_a_skuste_to_znovu }}
                    </div>

                    <div class="success-block" v-if="submitSuccess">
                        <span class="material-icons">done</span> {{ i18n.uloha_bola_uspesne_odovzdana }}
                    </div>
                    <div class="success-block" v-if="toggleSuccess">
                        <span class="material-icons">done</span> {{ i18n.ulohy_boli_uspesne_priradene }}
                    </div>

                    <div class="is-flex align-items-center justify-content-between">
                        <h3 class="h3">{{ i18n.o_com_je_tato_uloha }}</h3><span @click="close" class="cursor-pointer blue-link">{{ i18n.zatvorit }}</span>
                    </div>
                    <div class="headline-delimiter"></div>
                    <div class="academy-task">
                        <div class="is-flex align-items-center">
                            <img src="/assets/web/images/icons/dokument.png"
                                 class="academy-task-icon" :alt="activity.name" width="75">
                            <div class="pl-2 flex-grow-1">
                                <h4 class="academy-task-name">{{ activity.name }}</h4>
                                <p class="academy-task-breadcrumbs">{{ activity.module.name }},
                                    {{ activity.activity.name }}</p>
                                <p class="academy-task-perex">{{ activity.description }}</p>
                                <p class="academy-task-perex" v-if="activity.deadline">{{ i18n.termin_odovzdania }}
                                    <b>{{ activity.deadline }}</b></p>
                            </div>
                            <template v-if="user.role.includes('student') || user.role.includes('child')">
                                <template v-if="!activity.hasResult">
                                    <template v-if="activity.assignedToUser">
                                        <button v-if="activity.assignedToMe" type="button" @click="unassignActivity"
                                                onclick="return confirm(i18n.potvrdit_ostranenie_ulohy)"
                                                class="button button-small button-red">{{ i18n.odstranit_ulohu }}
                                        </button>
                                    </template>
                                    <button v-else type="button" @click="assignActivity" class="button button-small">
                                        {{ i18n.ulozit_ulohu }}
                                    </button>
                                </template>
                            </template>
                        </div>
                        <div class="tag mr-1" v-for="tag in activity.tags">
                          {{ tag }}
                        </div>
                        <div class="academy-task-meta is-flex align-items-center justify-content-between">
                            <div class="academy-task-meta-level"><b>{{ activity.level }}</b>
                            </div>
                            <div class="academy-task-meta-separator"></div>
                            <div class="academy-task-meta-time">{{ activity.time_goal }} min</div>
                            <template v-if="activity.assignedAt">
                                <div class="academy-task-meta-separator"></div>
                                <div class="academy-task-meta-time">{{ i18n.uloha_priradena_dna }}
                                    <b>{{ activity.assignedAt }}</b></div>
                            </template>
                        </div>
                    </div>

                    <div class="academy-task-text" v-html="activity.text"></div>


                    <!--                    Task detail / complete or assign -->

                    <!--                    Assigned to child -->

                    <template v-if="activity.assignedToUser || user.role.includes('teacher') || user.role.includes('superadmin') || user.role.includes('parent')">
                        <template v-if="activity.attachments">
                            <hr>
                            <h3 class="h3">{{ i18n.uloha_na_stiahnutie }}</h3>
                            <div class="headline-delimiter"></div>
                            <div class="is-flex academy-document align-items-center"
                                 v-for="document in activity.attachments[lang]">
                                <img src="/assets/web/images/icons/dokument.png"
                                     :alt="document.name" width="50">
                                <span class="pl-2 flex-grow-1">{{ document.name }}</span>
                                <a target="_blank"
                                   :href="fileDownloadRoute + '?path=' + document.path"
                                   class="button button-small">{{ i18n.stiahnut }}</a>
                            </div>
                        </template>
                        <template v-if="activity.bonus_task">
                            <hr>
                            <h3 class="h3">{{ i18n.doplnujuce_rozsirenie_ulohy }}</h3>
                            <div class="headline-delimiter"></div>
                            <div class="is-flex academy-document align-items-center"
                                 v-for="document in activity.bonus_task[lang]">
                                <img src="/assets/web/images/icons/dokument.png"
                                     :alt="document.name" width="50">
                                <span class="pl-2 flex-grow-1">{{ document.name }}</span>
                                <a target="_blank"
                                   :href="fileDownloadRoute + '?path=' + document.path"
                                   class="button button-small">{{ i18n.stiahnut }}</a>
                            </div>
                        </template>
                        <hr>
                        <template v-if="activity.assignedToUser">
                            <h3 class="h3" v-if="activity.hasResult">{{ i18n.tato_uloha_uz_bola_odovzdana }}</h3>
                            <template v-else>
                                <h3 class="h3">{{ i18n.odovzdat_hotovu_ulohu }}</h3>
                                <div class="headline-delimiter"></div>
                                <form @submit.prevent="submitActivity">
                                    <div class="form-input" v-if="activity.has_validation_question">
                                        <label class="form-input-label" for="validation_question">{{ i18n.odpoved_na_kontrolnu_otazku + ' ' + activity.validation_question}} *</label>
                                        <input type="text"
                                               class="form-input-element"
                                               :class="{'invalid-form-input-element': submitErrors && submitErrors['validation_answer']}"
                                               id="validation_question"
                                               v-model="submitValidationAnswer">
                                        <small class="invalid-form-input-message"
                                               v-if="submitErrors && submitErrors['validation_answer']">{{
                                                submitErrors['validation_answer'][0]
                                            }}</small>
                                    </div>
                                    <div class="form-input">
                                        <label class="form-input-label" for="files">{{ i18n.nahrat_subory }}</label>
                                        <input type="file" ref="files" multiple
                                               class="form-input-element"
                                               :class="{'invalid-form-input-element': submitErrors && (submitErrors['materials'] || submitErrors['materials.*'])}"
                                               id="files"
                                               v-on:change="handleFileUpload()">
                                        <small class="invalid-form-input-message"
                                               v-if="submitErrors && submitErrors['materials']">{{
                                                submitErrors['validation_answer'][0]
                                            }}</small>
                                        <small class="invalid-form-input-message"
                                               v-if="submitErrors && submitErrors['materials.*']">{{
                                                submitErrors['validation_answer'][0]
                                            }}</small>
                                    </div>
                                    <button type="submit" class="button">{{ i18n.odovzdat }}</button>
                                </form>
                            </template>
                        </template>
                    </template>

                    <!--                    User is teacher or parent -->

                    <template v-if="user.role.includes('teacher') && user.clubs.length">
                        <hr>
                        <h3 class="h3">{{ i18n.priradit_ulohy_ako_ucitel }}</h3>
                        <div class="headline-delimiter"></div>
                        <template v-if="user.clubs.length">
                            <form @submit.prevent="toggleActivities()">
                                <div v-for="club in user.clubs">
                                    <div class="item-selector">{{ club.name }}</div>
                                    <div class="form-input">
                                        <input type="checkbox" value="0" :id="'club-' + club.id"
                                               @click="toggleChildren('club-' + club.id, 'checkboxes-group-' + club.id)"
                                               class="form-input-element-checkbox">
                                        <label :for="'club-' + club.id">{{ i18n.oznacit_vsetky_moznosti }}</label>
                                    </div>
                                    <div :id="'checkboxes-group-' + club.id">
                                        <div class="form-input" v-for="student in club.students">
                                            <input type="checkbox" :id="'child-' + student.id"
                                                   v-model="children"
                                                   :value="student.id"
                                                   class="form-input-element-checkbox"
                                            >
                                            <label :for="'child-' + student.id">
                                                <template v-if="student.assignedToUser">
                                                    {{ i18n.odstranit }}
                                                </template>
                                                <template v-else>
                                                    {{ i18n.priradit }}
                                                </template>
                                                {{ i18n.ulohu + ' ' + student.name }}</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-input">
                                    <label for="deadline" class="form-input-label">{{ i18n.termin_odovzdania }}</label>
                                    <input type="text"
                                           class="form-input-element"
                                           :class="{'invalid-form-input-element': submitErrors && submitErrors['deadline']}"
                                           id="deadline" placeholder="Zadávajte v tvare 01.01.2000" v-model="deadline">
                                    <small class="invalid-form-input-message"
                                           v-if="submitErrors && submitErrors['deadline']">{{
                                            submitErrors['deadline'][0]
                                        }}</small>
                                </div>
                                <button type="submit" class="button">{{ i18n.ulozit_priradenie }}</button>
                            </form>
                        </template>
                    </template>

                    <template v-if="user.role.includes('parent') && user.children.length">
                        <hr>
                        <h3 class="h3">{{ i18n.priradit_ulohy_ako_rodic }}</h3>
                        <div class="headline-delimiter"></div>
                        <template v-if="user.children.length">
                            <form @submit.prevent="toggleActivities()">
                                <div class="form-input">
                                    <input type="checkbox" value="0" :id="'parent'"
                                           @click="toggleChildren('parent', 'checkboxes-group-parent')"
                                           class="form-input-element-checkbox">
                                    <label :for="'parent'">{{ i18n.oznacit_vsetky_moznosti }}</label>
                                </div>
                                <div :id="'checkboxes-group-parent'">
                                    <div class="form-input" v-for="child in user.children">
                                        <input type="checkbox" :id="'child-' + child.id"
                                               v-model="children"
                                               :value="child.id"
                                               class="form-input-element-checkbox"
                                        >
                                        <label :for="'child-' + child.id" :class="{'unassign_task_alert': child.assignedToUser}">
                                            <template v-if="child.assignedToUser">
                                                {{ i18n.odstranit }}
                                            </template>
                                            <template v-else>
                                                {{ i18n.priradit }}
                                            </template>
                                          {{ i18n.ulohu + ' ' + child.name }}</label>
                                    </div>
                                </div>
                                <div class="form-input">
                                    <label for="deadline" class="form-input-label">{{ i18n.termin_odovzdania }}</label>
                                    <input type="text"
                                           class="form-input-element"
                                           :class="{'invalid-form-input-element': submitErrors && submitErrors['deadline']}"
                                           id="deadline" placeholder="Zadávajte v tvare 01.01.2000" v-model="deadline">
                                    <small class="invalid-form-input-message"
                                           v-if="submitErrors && submitErrors['deadline']">{{
                                            submitErrors['deadline'][0]
                                        }}</small>
                                </div>
                                <button type="submit" class="button">{{ i18n.ulozit_priradenie }}</button>
                            </form>
                        </template>
                    </template>

                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: "AcademyTaskComponent",
    props: {
        id: Number,
        assigmentRoute: String,
        assigmentStore: String,
        assigmentDelete: String,
        assigmentToggle: String,
        assigmentSubmit: String,
        fileDownloadRoute: String
    },
    data: function () {
        return {
            isOpen: false,
            loading: false,
            user: null,
            activity: null,
            submitErrors: null,
            submitValidationAnswer: null,
            loadingTime: 1000,
            submitSuccess: false,
            toggleSuccess: false,
            files: '',
            children: [],
            deadline: null,
	        lang: document.documentElement.lang,
            i18n: i18n
        }
    },
    mounted() {
        window.addEventListener('keyup', event => {
            if (event.keyCode === 27) {
                this.close();
            }
        });
    },
    methods: {
        open() {
            this.isOpen = true;
            this.getActivity();
        },
        close() {
            this.isOpen = false;
        },
        getActivity() {
            this.loading = true;

            axios.get(this.assigmentRoute).then(response => {
                this.activity = response.data.activity;
                this.user = response.data.user;
                setTimeout(() => {
                    this.loading = false;
                }, this.loadingTime);
            }).catch(error => {

            })
        },
        assignActivity() {
            this.loading = true;

            axios.post(this.assigmentStore).then(response => {
                this.getActivity();
            }).catch(error => {

            })
        },
        unassignActivity() {
            this.loading = true;

            axios.delete(this.assigmentDelete).then(response => {
                this.getActivity();
            }).catch(error => {

            })
        },
        submitActivity() {
            this.loading = true;
            this.submitErrors = null;
            this.submitSuccess = false;

            let formData = new FormData();

            for (var i = 0; i < this.files.length; i++) {
                let file = this.files[i];

                formData.append('materials[' + i + ']', file);
            }

            if (this.submitValidationAnswer) {
                formData.append('validation_answer', this.submitValidationAnswer);
            }

            axios.post(this.assigmentSubmit, formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(response => {
                this.submitSuccess = true;
                this.getActivity();
            }).catch(error => {
                if (error.response.status === 422) {
                    this.submitErrors = error.response.data.errors;
                } else {
                    this.submitErrors = {error: true};
                }

                setTimeout(() => {
                    this.loading = false;
                }, this.loadingTime);
            }).then(() => {

            })
        },

        handleFileUpload() {
            this.files = this.$refs.files.files;
        },

        toggleActivities() {
            this.loading = true;
            this.toggleSuccess = false;

            axios.post(this.assigmentToggle, {
                children: this.children,
                deadline: this.deadline,
                activity_type_id: this.id
            }).then(response => {
                this.deadline = null;
                this.children = [];
                this.toggleSuccess = true;
                this.getActivity();
            }).catch(error => {

            })
        },

        toggleChildren(el, group) {
            let isChecked = document.getElementById(el).checked;
            let checkboxesGroup = document.getElementById(group);
            let checkboxes = checkboxesGroup.getElementsByTagName('input');

            for (var i = 0; i < checkboxes.length; i++) {
                checkboxes[i].checked = isChecked;
            }
        }
    }
}
</script>

<style scoped>

</style>
